export default __webpack_public_path__ + "static/media/minotaur.dfdd260b.svg";